import { createContext } from 'react';

/** Set when the conversation is an app run rather than a plain chat. */
export interface ConversationAppRun {
  runId: string;
  appKey: string;
  nameKey: string;
  nameDefault: string;
}

export interface ConversationSummary {
  conversationId: string;
  title: string | null;
  createdAt: string;
  lastActivityAt: string;
  messageCount: number;
  appRun?: ConversationAppRun | null;
}

export interface ConversationsContextType {
  conversations: ConversationSummary[];
  isLoading: boolean;
  error: string | null;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => void;
  fetchConversations: () => void;
  addConversation: (conversation: ConversationSummary) => void;
  updateConversation: (
    conversationId: string,
    updates: Partial<ConversationSummary>,
  ) => void;
  renameConversation: (conversationId: string, title: string) => Promise<void>;
  deleteConversation: (conversationId: string) => Promise<void>;
  prependConversation: (conversation: ConversationSummary) => void;
}

const ConversationsContext = createContext<ConversationsContextType | null>(null);

export default ConversationsContext;
